import { FeaturedText } from './FeaturedText';

export type { TypeFeaturedTextProps } from './types';
export default FeaturedText;
